<template>
  <v-dialog scrollable v-model="showDialogPaybet" max-width="300px">
    <template v-slot:activator="{ on }">
      <v-btn
        v-show="$store.state.operators.retail && item.paid == '0'"
        light
        small
        class="ml-1"
        v-on="on"
      >
        <span v-show="$vuetify.breakpoint.smAndDown">{{ $t("paybet") }}</span>
        <v-icon :right="$vuetify.breakpoint.smAndDown" size="24"
          >mdi-cash-plus</v-icon
        >
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="mb-0 pb-0">
        <div>
          <h3 class="headline mb-0 text-h5 lighten-2">
            {{ $t("paybet") }}
          </h3>
        </div>
        <v-spacer />
        <v-btn icon @click="showDialogPaybet = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="my-2 pb-0 white--text">
        <div>ID: {{ item.id }}</div>
        <div>{{ $t("client") }}: {{ item.punter }}</div>
        <div>{{ $t("type") }}: {{ typeBet(item.n_events) }}</div>
        <div>
          {{ $t("value") }}: {{ $t("labelCurrency") }} {{ item.amount }}
        </div>
        <div>
          {{ $t("return") }}: {{ $t("labelCurrency") }} {{ item.prize }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="mr-3"
          color="primary"
          @click="setBetPayed"
          :loading="loading"
          :disabled="loading"
          small
        >
          {{ $t("confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "dialogPaybetSimplified",
  props: ["item"],
  data: () => ({
    loading: false,
    showDialogPaybet: false,
  }),
  computed: {
    title() {
      return this.$t("paybet");
    },
  },
  methods: {
    setBetPayed() {
      this.loading = true;
      this.$request
        .post("/agent/retail/bets/setBetPayed", { id_bet: this.item.id })
        .then((resp) => {
          this.$store.commit("setFeedbackSnack", {
            msg: resp.data.messages,
            color: "success",
          });
          this.$store.commit("setSave", true);
          this.showDialogPaybet = false;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    typeBet: function(val) {
      const type = {
        1: "Simples",
        2: "Dupla",
        3: "Tripla",
      };
      return type[val] || "Multipla";
    },
  },
  filters: {
    dateFormat: function(val) {
      var date = new Date(val.replace(" ", "T")).toLocaleString();
      return date;
    },
  },
};
</script>
